export async function getList({ commit }, payload) {
  const { errResponse, data: responseData } = await this.$adminRepositories.appOptions.getList(payload);

  if (!errResponse) {
    return commit('setList', responseData.data);
  }
}

export async function findById({ commit }, id) {
  return await this.$adminRepositories.appOptions.show(id);
}

export async function update({ commit }, { id, ...payload }) {
  return await this.$adminRepositories.appOptions.update(id, payload);
}